import { TableV2 } from '@anytag/shared-atoms';
import { InstagramFeedPost } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerInstagramAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerInstagramPostsListTable } from './hooks';

export interface InfluencerInstagramPostsListProps extends TableData<InstagramFeedPost> {
  mainSocialAccountId?: number;
}

export const InfluencerInstagramPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: InfluencerInstagramPostsListProps) => {
  const { columns } = useInfluencerInstagramPostsListTable();

  return (
    <>
      <TableV2 data={data} loading={loading} rowHeight="62px" columns={columns} noTopBorderRadius hasBorder />

      <InfluencerInstagramAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
      />
    </>
  );
};
